import React from "react";
import { Box, Typography, Card, Button } from "@mui/material";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import DeleteIcon from "@mui/icons-material/Delete";

const OutlinedUploadBox = ({
  id,
  text,
  onChange,
  accept = "image/*",
  isSquare = false,
  width = "100%",
  preview,
  onDelete,
}) => (
  <Card
    variant="outlined"
    sx={{
      borderRadius: "16px",
      borderColor: "#90A4AE",
      textAlign: "center",
      minHeight: isSquare ? 170 : 110,
      height: isSquare ? 170 : 110, // Fix height for cover
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: "none",
      width,
      my: 2,
      cursor: "pointer",
      borderWidth: 1,
      position: "relative",
      "&:hover": {
        borderColor: "#7891b2",
      },
      overflow: "hidden", // for border crop
      p: 0,
    }}
  >
    {preview && onDelete && (
      <Button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onDelete();
        }}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          minWidth: "auto",
          width: 32,
          height: 32,
          borderRadius: "50%",
          bgcolor: "error.main",
          color: "white",
          zIndex: 10,
          "&:hover": {
            bgcolor: "error.dark",
          },
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>
    )}
    <input
      accept={accept}
      style={{ display: "none" }}
      id={id}
      type="file"
      onChange={onChange}
    />
    <label
      htmlFor={id}
      style={{
        width: "100%",
        height: "100%",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {preview ? (
        <img
          src={
            typeof preview === "string"
              ? preview
              : URL.createObjectURL(preview)
          }
          alt={isSquare ? "profile preview" : "banner preview"}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: isSquare ? 16 : 16, // match Card border
          }}
        />
      ) : (
        <>
          <ImageOutlinedIcon sx={{ fontSize: 42, color: "#90A4AE", mb: 1 }} />
          <Typography
            sx={{
              color: "#90A4AE",
              fontWeight: 400,
              mt: 1,
              lineHeight: 1.2,
              textDecoration: "none",
              fontSize: "14px",
            }}
          >
            {text}
          </Typography>
        </>
      )}
    </label>
  </Card>
);

export default function BusinessUploads({
  handleFileUpload,
  handleFileDelete,
  bannerPreview,
  profilePreview,
}) {
  return (
    <Box sx={{ width: "100%", maxWidth: 480, ml: 3 }}>
      <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 500 }}>
        business profile pic
      </Typography>
      <OutlinedUploadBox
        id="profile-upload"
        text={
          <>
            upload your business <br /> profile pic
          </>
        }
        onChange={(e) => handleFileUpload(e, "locationProfilePhoto")}
        onDelete={handleFileDelete ? () => handleFileDelete("locationProfilePhoto") : undefined}
        isSquare
        width="170px"
        preview={profilePreview}
      />

      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ fontWeight: 500, mt: 3 }}
      >
        business cover
      </Typography>
      <OutlinedUploadBox
        id="banner-upload"
        text="upload your new location banner photo"
        onChange={(e) => handleFileUpload(e, "locationBannerPhoto")}
        onDelete={handleFileDelete ? () => handleFileDelete("locationBannerPhoto") : undefined}
        width="100%"
        preview={bannerPreview}
      />
    </Box>
  );
}
